import { AST_TOKEN_TYPES, TSESTree } from '@typescript-eslint/types';
import { DatasourceColumnUIModel } from '@y42/datasource';
import { AggregationType, ColumnTypeEnum, QueryField } from '@y42/json-schema';
import * as uuid from 'uuid';
import { isNotNullish } from '../../util';
import { QueryFieldWithFunctionTree } from './query-field-with-function-tree.model';

export { QueryField };

/**
 * @deprecated
 */
export class QueryField__DEPRECATED {
  /** @deprecated */
  static construct(field: string, aggregation: AggregationType, type: ColumnTypeEnum): QueryFieldWithFunctionTree {
    return {
      field,
      type,
      aggregation: aggregation || AggregationType.Value,
      alias: '',
      id: uuid.v4(),
      lowCodeString: null,
      show_in_percentage: false,
      filters: [],
      functionTree: {} as TSESTree.Program,
    };
  }

  static findById(fields: QueryField[], lookForUuid: string): QueryField | null {
    return fields.find((q: QueryField) => q.id === lookForUuid) || null;
  }

  static isCalculatedField(queryField: QueryFieldWithFunctionTree, checkIfSetUp = false): boolean {
    if (checkIfSetUp) {
      return !!queryField.lowCodeString;
    }
    return isNotNullish(queryField.lowCodeString);
  }

  static isCalculatedFieldValid(
    queryField: QueryFieldWithFunctionTree,
    sourceColumns: DatasourceColumnUIModel[],
  ): boolean {
    if (!QueryField__DEPRECATED.isCalculatedField(queryField)) {
      throw new Error(`isCalculatedFieldValid() called on a non-calculated QueryField`);
    }

    const allColumnsStillExist = queryField.functionTree?.tokens
      ?.filter((token) => token.type === AST_TOKEN_TYPES.Identifier && token.value[0] === '@')
      .every((token) => {
        const fieldName = token.value.substring(1);
        return !!sourceColumns.find((column) => column.field_name === fieldName);
      });
    return !!allColumnsStillExist;
  }

  static shareTheSameFieldAndAggregation(...fields: QueryField[]) {
    return fields.every((field, index, array) => {
      if (index === 0) {
        return true;
      }
      const previousField = array[index - 1];
      return (
        field && previousField && field.field === previousField.field && field.aggregation === previousField.aggregation
      );
    });
  }
}

export function constructQueryField(
  field: string,
  aggregation: AggregationType,
  type: ColumnTypeEnum,
): QueryFieldWithFunctionTree {
  return {
    field,
    type,
    aggregation: aggregation || AggregationType.Value,
    alias: '',
    id: uuid.v4(),
    lowCodeString: null,
    show_in_percentage: false,
    filters: [],
    functionTree: {} as TSESTree.Program,
  };
}
